import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Message } from 'primeng';
import { IBankInfo } from '../../interfaces/bank';
import { ISelfBillingAgreement } from '../../interfaces/self-billing-agreement';
import { BankService, UserService } from '../../services';
import { SelfBillingAgreementService } from '../../services';

@Component({
  selector: 'new-bank-details',
  templateUrl: 'new-bank-details.component.html',
})
export class NewBankDetailsComponent implements OnInit {
  public bankForm: UntypedFormGroup;
  public msgs: Message[];
  public isBusy: boolean = false;
  public isImpersonating: boolean = false;

  public backTo: string;
  public sbAgreement: ISelfBillingAgreement;

  constructor(
    private bankService: BankService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private selfBillingService: SelfBillingAgreementService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.userService.isUserImpersonating().then((x) => {
      this.isImpersonating = x?.isImpersonating ?? false;
    });

    this.bankForm = this.formBuilder.group({
      id: [0],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(127)])],
      accountNumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^(\\d){7,8}$'),
          Validators.maxLength(8),
        ]),
      ],
      sortCode: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^(\\d){2}-(\\d){2}-(\\d){2}$'),
          Validators.maxLength(8),
        ]),
      ],
    });

    this.refreshData();

    this.selfBillingService.getActualSelfBillingAgreement().then((res) => {
      this.sbAgreement = res;
    });

    this.msgs = [];
  }

  refreshData() {
    this.bankService.getCurrentOrgBankAccount().then((res) => {
      if (res) {
        this.bankForm = this.formBuilder.group({
          id: [res.id],
          name: [res.name, Validators.compose([Validators.required, Validators.maxLength(127)])],
          accountNumber: [
            res.accountNumber,
            Validators.compose([
              Validators.required,
              Validators.pattern('^(\\d){7,8}$'),
              Validators.maxLength(8),
            ]),
          ],
          sortCode: [
            res.sortCode,
            Validators.compose([
              Validators.required,
              Validators.pattern('^(\\d){2}-(\\d){2}-(\\d){2}$'),
              Validators.maxLength(8),
            ]),
          ],
        });
      }
    });
  }

  saveForm(formValues) {
    let bankInfo = <IBankInfo>formValues;
    this.bankService.save(bankInfo).then((data) => {
      //console.log(data);
      if (data) {
        if (this.backTo) {
          this.router.navigate([this.backTo]);
        } else {
          this.refreshData();
        }
      } else {
        this.msgs.push({
          severity: 'error',
          summary: 'Error Message',
          detail: data.errors.map((e) => e.description).join(';'),
        });
      }
    });
  }
}
